import { takeLatest, delay, buffers } from 'redux-saga'
import { put, call, select, actionChannel, take } from 'redux-saga/effects'
import { autosaveSelector, lockedSelector, compareUpdatedAtSelector } from 'selectors'
import updateDocumentSaga from 'sagas/updateDocumentSaga'
import compressProject from 'helpers/projects/compressProject'
import getDocument from 'helpers/databases/getDocument'
import { notifyHoneybadgerAction, updateUpdatedAtAction, lockProjectAction } from 'actions/applicationActions'
import { updateProjectAction } from 'actions/projectActions'
import { messageAction } from 'actions/messageActions'
import { EXCLUDED_AUTOSAVE_ACTIONS } from 'helpers/globals'
import { START_AUTOSAVE_SAGA, AUTOSAVE } from 'actions/applicationActionTypes'

function * checkIfUpdatedOnAnotherDevice() {
  const { _id, database, currentProjectUpdatedAt } = yield select(compareUpdatedAtSelector)
  const { updatedAt } = yield call(getDocument, database, _id)
  return currentProjectUpdatedAt < updatedAt
}

export function * autosave() {
  try {
    const locked = yield call(checkIfUpdatedOnAnotherDevice)
    if (locked) {
      yield put(lockProjectAction())
      return
    }
    yield call(delay, 1500)

    const updatedAt = Date.now()
    yield put(updateProjectAction({ updatedAt }))
    yield put(updateUpdatedAtAction(updatedAt))

    const { currentEntity, currentProjectMetadata, cameras, map, ui, projects,
      createdAt, favoriteModels, recentModels, favoriteDoorControllerModels, recentDoorControllerModels,
      userSettings, entities } = yield select(autosaveSelector)

    if (!map) return

    const project = compressProject({
      mapLocation: map.location,
      zoom: map.zoom,
      markups: map.markups,
      floorPlans: map.floorPlans,
      mapType: map.mapType,
      title: projects
               .find(p => p.id === currentProjectMetadata._id)
               .title,
      cameras,
      entities,
      ui,
      createdAt,
      updatedAt,
      currentEntity
    })

    yield call(updateDocumentSaga, project, currentProjectMetadata._id)

    yield call(
      updateDocumentSaga,
      { favoriteModels, recentModels, favoriteDoorControllerModels, recentDoorControllerModels, userSettings },
      currentProjectMetadata.settingsId
    )

    yield put(messageAction('saveState', 'Saving...'))
  } catch (err) {
    yield put(notifyHoneybadgerAction(err, { type: AUTOSAVE }))
  }
}

export function * watchAutosave() {
  const autosaveChannel = yield actionChannel(a => !EXCLUDED_AUTOSAVE_ACTIONS.includes(a.type), buffers.dropping(0))
  // call autosave on initialization
  yield call(autosave)
  while (true) {
    yield take(autosaveChannel)
    const { locked } = yield select(lockedSelector)
    if (!locked) yield call(autosave)
  }
}

export function * watchStartAutosave() {
  yield * takeLatest(START_AUTOSAVE_SAGA, watchAutosave)
}



// WEBPACK FOOTER //
// ./src/sagas/autosaveSaga.js